import { dropdownWrapperCss } from "../ActionsDropdown/ActionsDropdown.style";

export const popoutContainerCss = {
  ...dropdownWrapperCss,
  maxHeight: "400px",
  overflowY: "scroll",
  listStyleType: "none",
  width: "225px",
  padding: 0,
};
